const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getAsIntroducerIdFromUrl = (): string | undefined => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("as_introducer_id");
    if (raw === null) return undefined;
    return UUID_RE.test(raw) ? raw : undefined;
};

export const withAsIntroducerId = (path: string, asIntroducerId: string | undefined): string => {
    if (asIntroducerId === undefined) return path;
    const sep = path.includes("?") ? "&" : "?";
    return `${path}${sep}as_introducer_id=${encodeURIComponent(asIntroducerId)}`;
};
